import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import IUser from '../../../_interfaces/IUser';
import {
  readAdminCustomerRouteParam,
  readRouteParam,
} from '../../../_utils/route-param.utils';
import { AdminDetailShellComponent, AdminDetailTab } from '../../../components/admin-ui/admin-detail-shell/admin-detail-shell.component';
import { AdminEntityLoaderService } from '../../../_services/admin/admin-entity-loader.service';

@Component({
  selector: 'app-admin-user-detail',
  standalone: true,
  imports: [AdminDetailShellComponent],
  templateUrl: './admin-user-detail.component.html',
  styleUrl: './admin-user-detail.component.scss',
})
export class AdminUserDetailComponent implements OnInit {
  public customersId = 0;
  public usersId = 0;
  public user: IUser | null = null;
  public tabs: AdminDetailTab[] = [
    {
      route: 'profile',
      labelKey: 'COMMON.PERSONAL_DATA',
      icon: 'fas fa-id-card',
    },
    {
      route: 'employee',
      labelKey: 'COMMON.EMPLOYEE_DATA',
      icon: 'fas fa-briefcase',
    },
    {
      route: 'access',
      labelKey: 'ADMIN.USERS.ACCESS',
      icon: 'fas fa-user-shield',
    },
    {
      route: 'security',
      labelKey: 'COMMON.SECURITY',
      icon: 'fas fa-lock',
    },
    {
      route: 'landing',
      labelKey: 'ADMIN.USERS.DETAIL.SECURITY.LANDING_TITLE',
      icon: 'fas fa-house',
    },
  ];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loader: AdminEntityLoaderService,
  ) {}

  get backLink(): any[] {
    return [
      '/administration',
      readAdminCustomerRouteParam(this.route, this.customersId) || this.customersId,
      'users',
    ];
  }

  get userDisplayName(): string {
    const fullName = [this.user?.name, this.user?.surname]
      .filter(Boolean)
      .join(' ')
      .trim();
    return fullName || this.user?.email || '';
  }

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
    this.usersId = readRouteParam(this.route, 'users_id');

    const resolvedUser = (this.route.snapshot.data['user'] || null) as IUser | null;
    if (resolvedUser) {
      this.user = resolvedUser;
    }

    if (this.customersId && this.usersId) {
      this.loader.loadUser(this.customersId, this.usersId).subscribe({
        next: (user) => {
          if (user) {
            this.user = user;
          }
        },
      });
    }
  }
}
